import { atom } from 'jotai';
import { persistedEnumAtom } from '@/core/state';
import { StorageKey } from '@/core/storage';
import type { Station } from '../model/types';

// Read these freely; change them through the action atoms in ./actions.ts.

export const stationsVisibilityAtom = persistedEnumAtom<'on' | 'off'>(
  StorageKey.Stations,
  ['on', 'off'],
  'on',
);

/** Every station loaded recently, by id; what is drawn is a thinned-out subset (see thinStations). */
export const stationCacheAtom = atom<ReadonlyMap<string, Station>>(new Map());

export type LoadStatus = { kind: 'idle' } | { kind: 'loading' } | { kind: 'error'; error: unknown };

export const loadStatusAtom = atom<LoadStatus>({ kind: 'idle' });

/** Station whose details popup is open. */
export const selectedStationIdAtom = atom<string | null>(null);

export const selectedStationAtom = atom((get) => {
  const id = get(selectedStationIdAtom);
  return id === null ? null : (get(stationCacheAtom).get(id) ?? null);
});
